var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.campaignMessage.length > 0)?_c('div',{staticClass:"line-campaign-message",style:(_vm.styles)},[_c('span',{staticClass:"mess",domProps:{"innerHTML":_vm._s(_vm.campaignMessage)}}),_c('span',{staticClass:"bg"})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122513fa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/partials/LineCampaignMessage.vue
// module id = null
// module chunks = 